export enum KioskStateEnum {
  Reset = 0,
  ChildManagement = 50,
  AddChild = 60,
  EditChild = 70,
  Birthday = 100,
  SelectBookingEventProducts = 110,
  SelectBookingExtraProducts = 120,
  LoginOrRegister = 130,
  CreateOrder = 140,
  RegisterWithOrder = 150,
  OrderComplete = 160,
  ThankYou = 170,
}
